<template>
    <section>
        <blast-tabs body-class="container" header-class="profile-header-tabs" container-class="container">
            <blast-tab :id="tabs[0]" :label="$t(`wi.${tabs[0]}`.toLowerCase())" v-if="this[`has${tabs[0]}`]" :is-active="isDefaultTab(tabs[0])" :classes="summaryClass">
                <highlight-videos v-if="hasVideos" :profile-type="profileType"/>
                <biography v-if="hasBio" />
            </blast-tab>

            <blast-tab :id="tabs[1]" :label="$t(`wi.${tabs[1]}`.toLowerCase())" v-if="this[`has${tabs[1]}`]" :is-active="isDefaultTab(tabs[1])" :classes="athleticsClass">
                <baseball-athletics v-if="isAcademySoftball || isAcademyBaseball"/>
                <golf-athletics v-if="isAcademyGolf" />
                <teams v-if="hasTeams"/>
                <additional-sports v-if="hasAdditionalSports"/>
            </blast-tab>

            <blast-tab :id="tabs[2]" :label="$t(`wi.${tabs[2]}`.toLowerCase())" v-if="this[`has${tabs[2]}`]" :is-active="isDefaultTab(tabs[2])" :classes="academicsClass">
                <academics/>
            </blast-tab>

            <blast-tab :id="tabs[3]" :label="$t(`wi.${tabs[3]}`.toLowerCase())" v-if="this[`has${tabs[3]}`]" :is-active="isDefaultTab(tabs[3])" :classes="statsClass">
                <metrics v-if="hasStatsMetrics" />
                <stats v-if="hasStatsAthletics || hasStatsPerformances" />
            </blast-tab>

            <blast-tab :id="tabs[4]" :label="$t(`wi.${tabs[4]}`.toLowerCase())" v-if="this[`has${tabs[4]}`]" :is-active="isDefaultTab(tabs[4])" :classes="contactClass">
                <contacts v-if="hasContactData" />
                <parents v-if="hasParentsData" />
            </blast-tab>
        </blast-tabs>
    </section>
</template>

<script>
    import academyMixin from '../../PlayerProfile/mixins/academy';
    import publishMixin from '../../PlayerProfile/mixins/publish-settings';
    import { mapGetters } from 'vuex';
    import Stats from '../../PlayerProfile/components/Stats/Stats';
    import Metrics from '../../PlayerProfile/components/Stats/Metrics';
    import Contacts from '../../PlayerProfile/components/Contacts';
    import Parents from '../../PlayerProfile/components/Parents';
    import Biography from '../../PlayerProfile/components/Biography';
    import Academics from '../../PlayerProfile/components/Academics';
    import HighlightVideos from '../../PlayerProfile/components/HighlightVideos/HighlightVideos';
    import Teams from '../../PlayerProfile/components/Athletics/Teams';
    import AdditionalSports from '../../PlayerProfile/components/Athletics/AdditionalSports';
    import BaseballAthletics from '../../PlayerProfile/components/Athletics/BaseballAthletics';
    import GolfAthletics from '../../PlayerProfile/components/Athletics/GolfAthletics';

    export default {
        name: 'PublishProfileBody',

        mixins: [publishMixin, academyMixin],

        props: {
            profileType: {
                type: String,
                default: 'blast'
            }
        },

        data() {
            return {
                defaultTab: null,
                tabs: [
                    'Summary',
                    'Athletics',
                    'Academics',
                    'Stats',
                    'Contacts'
                ],

                gaClasses: {
                    blast: {
                        summary: 'ga-profile-view-summary',
                        athletics: 'ga-profile-view-athletics',
                        academics: 'ga-profile-view-academics',
                        stats: 'ga-profile-view-stats',
                        contact: 'ga-profile-view-contact'
                    },
                    ncsa: {
                        summary: 'ga-ncsa-clicked-summary-tab',
                        athletics: 'ga-ncsa-clicked-athletics-tab',
                        academics: 'ga-ncsa-clicked-academics-tab',
                        stats: 'ga-ncsa-clicked-stats-tab',
                        contact: 'ga-ncsa-clicked-contact-tab'
                    }
                }
            }
        },

        components: {
            Stats,
            Metrics,
            Contacts,
            Parents,
            Biography,
            Academics,
            HighlightVideos,
            Teams,
            AdditionalSports,
            BaseballAthletics,
            GolfAthletics
        },

        methods: {
            isDefaultTab(tab) {
                return this.defaultTab === tab;
            },
        },

        computed: {
            ...mapGetters({
                roles: 'player-profile/roles',
            }),

            summaryClass() {
                return 'ga-event ' + this.gaClasses[this.profileType].summary;
            },

            athleticsClass() {
                return 'ga-event ' + this.gaClasses[this.profileType].athletics;
            },

            academicsClass() {
                return 'ga-event ' + this.gaClasses[this.profileType].academics;
            },

            statsClass() {
                return 'ga-event ' + this.gaClasses[this.profileType].stats;
            },

            contactClass() {
                return 'ga-event ' + this.gaClasses[this.profileType].contact;
            },
        },

        created() {
            this.tabs.reverse().forEach((tab) => {
                if (this[`has${tab}`]) {
                    this.defaultTab = tab;
                }
            });

            this.tabs.reverse();
        }
    }
</script>

